function Footer() {
  return (
    <footer className=" mt-4 text-center text-muted">
      <p>Estyn AI Tool &copy; {new Date().getFullYear()}</p>
    </footer>
  );
}

export default Footer;
